import { Link } from 'react-router-dom';
import './ancerWithUnderlineSmall.css';

function AncerWithUnderlineSmall(props) {
  const { text, to, customClass } = props;
  return (
    <div className="underline_ancer_smallContainer">
      <Link className={`underline_ancer_small ${customClass}`} to={to || ''}>
        {text || ''}
      </Link>
    </div>
  );
}

export default AncerWithUnderlineSmall;
